import { Star } from 'lucide-react';
import { cn } from '../../utils';

export type StarRatingDisplayProps = {
  value: number;
  max?: number;
  size?: number;
  showNumeric?: boolean;
  className?: string;
};

export function StarRatingDisplay({
  value,
  max = 5,
  size = 18,
  showNumeric = true,
  className,
}: StarRatingDisplayProps) {
  const clampedValue = Math.min(Math.max(value, 0), max);

  return (
    <div className={cn('inline-flex items-center gap-1.5', className)}>
      <div className="inline-flex items-center gap-0.5">
        {Array.from({ length: max }, (_, i) => {
          const starValue = i + 1;
          const isFull = starValue <= Math.floor(clampedValue);
          const isPartial =
            !isFull && starValue === Math.ceil(clampedValue) && clampedValue % 1 > 0;

          return (
            <span key={starValue} className="relative inline-block" style={{ width: size, height: size }}>
              {/* Background (empty) star */}
              <Star
                size={size}
                className="fill-transparent text-muted-foreground/30"
              />
              {/* Filled star (full or partial) */}
              {(isFull || isPartial) && (
                <span
                  className="absolute inset-0 overflow-hidden"
                  style={{ width: isPartial ? `${(clampedValue % 1) * 100}%` : '100%' }}
                >
                  <Star
                    size={size}
                    className="fill-yellow-400 text-yellow-400"
                  />
                </span>
              )}
            </span>
          );
        })}
      </div>
      {showNumeric && (
        <span className="text-sm font-medium text-muted-foreground">
          {clampedValue.toFixed(1)}/{max}
        </span>
      )}
    </div>
  );
}
